export const GOOGLE_OAUTH_STATE_KEY = 'google_oauth_state';

function generateGoogleOAuthState() {
    if (window.crypto && window.crypto.getRandomValues) {
        const values = new Uint32Array(4);
        window.crypto.getRandomValues(values);
        return Array.from(values).map((value) => value.toString(16)).join('');
    }

    return `${Date.now()}_${Math.random().toString(16).slice(2)}`;
}

export function isGoogleLoginEnabled() {
    return String(process.env.REACT_APP_ENABLE_GOOGLE_LOGIN).toLowerCase() === 'true';
}

export function isGoogleOAuthConfigured() {
    return Boolean(process.env.REACT_APP_GOOGLE_CLIENT_ID)
        && Boolean(process.env.REACT_APP_GOOGLE_REDIRECT_URI);
}

export function storeGoogleOAuthState() {
    const state = generateGoogleOAuthState();
    sessionStorage.setItem(GOOGLE_OAUTH_STATE_KEY, state);
    return state;
}

export function getStoredGoogleOAuthState() {
    return sessionStorage.getItem(GOOGLE_OAUTH_STATE_KEY);
}

export function clearStoredGoogleOAuthState() {
    sessionStorage.removeItem(GOOGLE_OAUTH_STATE_KEY);
}

export function buildGoogleAuthorizationUrl(state) {
    const params = new URLSearchParams({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        redirect_uri: process.env.REACT_APP_GOOGLE_REDIRECT_URI,
        response_type: 'code',
        scope: 'openid email profile',
        prompt: 'select_account',
        state
    });

    return `https://accounts.google.com/o/oauth2/v2/auth?${params.toString()}`;
}
